@if (product && providerProduct) {
    <p-table
        #dt1 [value]="providerProductVariantItems" [scrollable]="true" [paginatorDropdownAppendTo]="'body'"
        [tableStyle]="{ 'min-width': '50rem' }" [styleClass]="'p-datatable-sm'"
        [globalFilterFields]="['VariantKey', 'VariantValue']"  stripedRows>
        <ng-template #caption>
            <div class="flex gap-2">

              <p-inputgroup class="!w-auto" styleClass="!w-auto">
                <p-inputgroup-addon>
                  <i class="pi pi-search"></i>
                </p-inputgroup-addon>
                <input
                    #globalSearch pInputText type="text" #filter
                    (input)="dt1.filterGlobal($any($event.target).value ?? '', 'contains')" placeholder="Arama..."/>
      </p-inputgroup>
                @if (globalSearch.value.length > 0) {
                    <p-button
                      [outlined]="true" label="Filtreyi Kaldır"  icon="pi pi-filter-slash"
                            (click)="clear(dt1); filter.value =''"></p-button>
                }



                <div class="ml-auto">
                    <p-button
                      [outlined]="true" label="Özellik Eşleştir" (click)="featureMatch()" class=" mr-2 "
                            icon="pi pi-sort-alt"></p-button>

                    <p-button
                            label="Eşleşmeleri Temizle" icon="pi pi-trash" [outlined]="true" (click)="clearMatch()"
                            severity="secondary"></p-button>


                </div>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>

                <th style="width: 10%;">
                    Adı
                </th>
                <th style="width:25%">
                    Varyant
                </th>
                <th style="width:25%">
                    Değeri
                </th>

                <th style="width:15%">
                    Eşleşme Durumu

                </th>


                <!--      <th pSortableColumn="customerName" style="width:25%">Ad Soyad <p-sortIcon field="customerName"></p-sortIcon></th>
                      <th pSortableColumn="number" style="width:25%">Sipariş Numarası<p-sortIcon field="number"></p-sortIcon></th>
                      <th pSortableColumn="status" style="width:25%">Durumu<p-sortIcon field="status"></p-sortIcon></th>
                      <th pSortableColumn="message" style="width:25%">Mesaj<p-sortIcon field="message"></p-sortIcon></th>-->
            </tr>


        </ng-template>
        <ng-template #body let-variantItem>
            <tr>
                <td>{{ variantItem.VariantKey }}
                    / {{ variantItem.VariantValue }}
                </td>
                <td>
                    {{ variantItem.toLocaleLowerCaseName }}

                            <p-select
                              class="w-full"
                                    [options]="providerCategoryAttributes" [filter]="true" filterBy="Name"
                                    appendTo="body" [ngModel]="variantItem.lowercaseName"
                                    (ngModelChange)="changeName($event,variantItem)" [virtualScroll]="true"
                                    [virtualScrollItemSize]="20" optionLabel="Name" optionValue="lowercaseName"
                                    placeholder="{{variantItem.VariantKey}} Seçimi Yapınız"></p-select>


                </td>
                <td>
                    @if (variantItem.NameMatchin) {
                        @if (variantItem.Values.length > 0) {
                                    <p-select
                                      class="w-full"
                                            [options]="variantItem.Values" [filter]="true" filterBy="Value"
                                            appendTo="body" [ngModel]="variantItem.lowercaseValue"
                                            (ngModelChange)="changeValue($event,variantItem)" [virtualScroll]="true"
                                            [virtualScrollItemSize]="20" optionLabel="Value"
                                            optionValue="lowercaseValue"
                                            placeholder="{{variantItem.VariantValue}} Seçimi Yapınız"></p-select>

                        } @else {

                                    <input
                                      class="w-full"
                                            type="text" [ngModel]="variantItem.Value"
                                            (ngModelChange)="changeValue($event,variantItem)"
                                            placeholder="{{variantItem.VariantValue}} Alanını Doldurun" pInputText/>

                        }
                    } @else {
                        <p-chip [label]="variantItem.VariantKey + ' Alanının Karşılığını Seçiniz'"></p-chip>

                    }
                </td>
                <td>
                    @if (variantItem.NameMatchin && variantItem.ValueMatchin) {
                        <p-chip styleClass="pl-0 pr-4">
                        <span class="bg-green-200 text-white rounded-full w-8 h-8 flex items-center justify-center"><i
                                class="pi pi-check"></i></span>
                            <span class="ml-2 font-medium mr-2">Eşleşti</span>
                        </p-chip>

                    } @else {
                        <p-chip styleClass="pl-0 pr-4">
                        <span class="bg-red-200 text-white rounded-full w-8 h-8 flex items-center justify-center"><i
                                class="pi pi-times"></i></span>
                            <span class="ml-2 font-medium mr-2">Eşleşmedi</span>
                        </p-chip>

                    }
                </td>

            </tr>
        </ng-template>

    </p-table>

}

<div class="flex gap-2 border-t border-surface pt-4">


    <div class="ml-auto">


        <button
                (click)="ref.close(providerProductVariantItems)" pButton icon="pi pi-check" label="Kaydet"></button>


    </div>
</div>
